<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <p>
          These {{policy.length}} policies make up your practice's entire Information Security Policy (a.k.a. Policies and Procedures Manual). Carefully read, edit where required, and approve each document.
          <u>Note</u>: You are not required to print these policies&#59; keeping them in electronic form (here) is fine.
        </p>
        <b-button type="button" variant="primary" class="px-4" v-show="ready && approvedPolicy" to="/print/policy-print-all" target="_blank">Print Policies</b-button>
        <hm-spinner v-if="!ready" />
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered hover show-empty empty-text="No Policies" :items="policy" :fields="columns" @row-clicked="rowClick">
          <template slot="cell(name)" slot-scope="data">{{data.item.index}}. {{data.item.name}}</template>
          <template slot="cell(approved)" slot-scope="data">
            <span>{{data.value|formatDate('YYYY-MM-DD')}}</span>
            <span v-if="!data.value" class="badge badge-danger ml-2">START</span>
            <span v-else-if="daysOld(data.value) >= 365" class="badge badge-danger ml-2">REVIEW</span>
            <span v-else-if="daysOld(data.value) >= 335" class="badge badge-warning ml-2">REVIEW</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { policyService } from '@/services'

export default {
  name: 'PolicyList',
  data() {
    return {
      policy: [],
      columns: [{
        key: 'name',
        label: 'Policy'
      }, {
        key: 'approved',
        label: 'Last Approved'
      }],
      ready: false
    }
  },
  computed: {
    approvedPolicy() {
      // return true if at least one policy is approved
      for (let i = 0; i < this.policy.length; i++) {
        if (this.policy[i].approved) return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    rowClick(record, index) {
      this.$router.push({ name: 'PolicyEdit', params: { id: record.id } });
    },
    daysOld(d) {
      return (this.$options.filters.daysOld(d));
    }
  },
  created() {
    this.ready = false;

    policyService.getPolicy()
      .then(data => {
        this.policy = data;
      })
      .catch(err => {
        this.alertException({ err, message: 'Error loading policy data.' });
      }).finally(() => {
        this.ready = true;
      })
  }
}
</script>
